import Icon from '../components/Icon';

const Reverse = Icon(
  'reverse',
  <>
    <path d="M18.03 10.03a.75.75 0 1 1-1.06-1.06l1.72-1.72H7.5A3.75 3.75 0 0 0 3.75 11a.75.75 0 0 1-1.5 0c0-2.9 2.35-5.25 5.25-5.25h11.19l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06zM6.03 19.97a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06l-1.72 1.72H15.5A3.75 3.75 0 0 0 19.25 13a.75.75 0 0 1 1.5 0c0 2.9-2.35 5.25-5.25 5.25H4.31z" />
  </>
);

export default Reverse;
